{
  "es": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Cambiar logotipo (PNG obligatorio)",
        "changeThemeColor": "Elige un nuevo color de tema"
      },
      "errors": {
        "themeColorInvalid": "Introduce seis caracteres, 0-9 o A-F. Por ejemplo 096553."
      },
      "labels": {
        "customerThemeColor": "Color de tema del cliente",
        "customerThemeColorExlainer": "Este color se usará en el portal del cliente. Suplanta a un cliente para verlo en acción.",
        "logo": "Logotipo"
      },
      "picture_logo_format": {
        "round": "Logotipo redondo",
        "square": "Logotipo cuadrado"
      }
    }
  }
}
